import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import SeriesDataPage from './SeriesDataPage';

const ZVSeriesPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const selectedModel = searchParams.get('model');

  const handleModelSelect = (modelName) => {
    navigate(`?model=${encodeURIComponent(modelName)}`);
  };

  const handleBackToSelection = () => {
    navigate('');
  };

  return (
    <SeriesDataPage 
      seriesKey="ZV" 
      selectedModel={selectedModel}
      onModelSelect={handleModelSelect}
      onBackToSelection={handleBackToSelection}
    />
  );
};

export default ZVSeriesPage;